// test1826
(1826 && 0);
